import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { seasonsCardMotion } from './motion';
import { seasonsChromeTone } from './palette';

export const seasonsTheme: FlowThemeDefinition = {
  id: 'seasons',
  label: 'Four Seasons',
  description: 'A great old tree grows through the year, one blossoming branch for every answer, and bursts into bloom at golden hour.',
  category: 'daylight',
  chromeTone: seasonsChromeTone,
  swatch: 'linear-gradient(135deg, #2B3A6B 0%, #8FB0D8 30%, #7DBB5C 50%, #E0912F 72%, #F2A0B8 100%)',
  cardGlass: 'default',
  cardMotion: seasonsCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createSeasonsScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
